import API_BASE_URL from './apiBaseUrl'

export default `${API_BASE_URL}/graphql`
